export function pluralize(word: string): string | undefined {
  if (
    word.endsWith('s') ||
    word.endsWith('sh') ||
    word.endsWith('ch') ||
    word.endsWith('x') ||
    word.endsWith('z')
  )
    return `${word}es`;

  if (word.endsWith('y') && !'aeiou'.includes(word.slice(-2, -1))) {
    // Words ending in "y" preceded by a consonant become plural by changing "y" to "ies."
    return `${word.slice(0, -1)}ies`;
  }

  if (word.endsWith('o') && !'aeiou'.includes(word.slice(-2, -1))) {
    // Words ending in "o" preceded by a consonant typically become plural by adding "es."
    return `${word}es`;
  }

  return `${word}s`;
}
